import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-card__labels"
}
const _hoisted_2 = {
  key: 0,
  class: "gfu-card__media"
}
const _hoisted_3 = {
  key: 0,
  class: "gfu-card__content"
}
const _hoisted_4 = {
  key: 1,
  class: "gfu-card__actions"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent($props.tag), {
    class: _normalizeClass($options.classes)
  }, {
    default: _withCtx(() => [
      (_ctx.$slots.labels)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "labels")
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass(['gfu-card__wrap', $props.extendedWrapperClass])
      }, [
        (_ctx.$slots.media)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "media")
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
          class: _normalizeClass($options.cardBodyClasses)
        }, [
          (_ctx.$slots.body)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "body")
              ]))
            : _createCommentVNode("v-if", true),
          _renderSlot(_ctx.$slots, "default"),
          (_ctx.$slots.actions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "actions")
              ]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */)
      ], 2 /* CLASS */)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["class"]))
}